module.exports = __webpack_public_path__ + "static/media/client25.38badd2c.webp";